{
  "facility.name": "Helsingfors-Vanda flygplats drop-off-område",
  "facility.webpage.url": "https://www.finavia.fi/sv",
  "facility.customerService.url": "https://customerservice.finavia.fi/sv-SE/support/home",
  "facility.privacyPolicy.url": "https://www.finavia.fi/fi/media/7837/download",
  "facility.privacyPolicy.text": "Integritetspolicy",

  "document.title": "Helsingfors-Vanda drop-off",

  "page.webPayment.paymentProvider.heading": "Betaltjänstleverantör",
  "page.webPayment.paymentProvider.information": "Som betalningsförmedlingstjänst och betaltjänstleverantör fungerar Paytrail Oyj (2122839-7) i samarbete med finska banker och kreditinstitut. Paytrail Oyj visas som mottagare av betalningen på kontoutdraget eller kortfakturan och vidarebefordrar betalningen till handlaren. Paytrail Oyj har ett verksamhetstillstånd för betalningsinstitut. Vid reklamationer ber vi dig först kontakta produktens leverantör.",
  "page.webPayment.paymentProvider.details1": "Paytrail Oyj, FO-nummer: 2122839-7",
  "page.webPayment.paymentProvider.details2": "Innova 2",
  "page.webPayment.paymentProvider.details3": "Lutakonaukio 7",
  "page.webPayment.paymentProvider.details4": "40100 Jyväskylä",
  "page.webPayment.paymentProvider.url": "https://www.paytrail.com/kuluttaja/information-om-betalning",

  "page.webPayment.stepFillLicensePlate.info.pay": "Betala för ditt besök inom 48 timmar",
  "page.webPayment.stepFillLicensePlate.info.notPaid": "Har du besökt Helsingfors-Vanda flygplats drop-off-område och inte betalat än?",
  "page.webPayment.stepFillLicensePlate.info.licensePlate": "Ange ditt registreringsnummer för att hämta information om ditt besök:",
  "page.webPayment.stepFillLicensePlate.button.find": "Sök fordon",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate": "Registreringsnumret",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter": "Ange",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate": "Ange ett giltigt registreringsnumret.",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.info.format": "i formen ABC-123 eller ABC123",
  "page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents": "Inga obetalda besök hittades för registreringsnumret {licensePlate}.",
  "page.webPayment.stepFillLicensePlate.alert.body.reason": "Detta kan bero på olika orsaker.",
  "page.webPayment.stepFillLicensePlate.alert.body.desc1": "Ditt besök på drop-off-området var kostnadsfritt",
  "page.webPayment.stepFillLicensePlate.alert.body.desc2": "Det har gått 48 timmar sedan besöket och en faktura eller betalningspåminnelse har skickats per post baserat på registreringsnumret",
  "page.webPayment.stepFillLicensePlate.alert.body.desc3": "Du angav fel registreringsnumret",
  "page.webPayment.stepFillLicensePlate.getInvoice.errorToast": "Ett fel uppstod vid hämtning av data. Försök igen senare.",

  "page.webPayment.stepInvoice.info.invoice": "Dina betalningar",
  "page.webPayment.stepInvoice.info.invoiceDescription": "{count, plural, one {Ett obetalt besök hittades med registreringsnumret {licensePlate}.} other {{count} obetalda besök hittades med registreringsnumret {licensePlate}.}}",
  "page.webPayment.stepInvoice.button.payParking": "Betala",
  "page.webPayment.stepInvoice.button.payParking.loading": "Bearbetar...",
  "page.webPayment.stepInvoice.cardInvoice.parkingStarted": "Besöket började",
  "page.webPayment.stepInvoice.cardInvoice.duration": "Längd",
  "page.webPayment.stepInvoice.cardInvoice.parkingPrice": "Besöksavgift",
  "page.webPayment.stepInvoice.cardInvoice.vatIncluded": "Inkl. moms {vat}% {vatPrice}",
  "page.webPayment.stepInvoice.contactInformation.description": "E-postadress krävs för kvitto och eventuell återbetalning.",
  "page.webPayment.stepInvoice.emailAddress": "E-postadress",
  "page.webPayment.stepInvoice.form.email.errors.email": "Ange en giltig e-postadress.",
  "page.webPayment.stepInvoice.form.email.errors.required": "E-postadress krävs.",
  "page.webPayment.stepInvoice.error.initiatePayment": "Ett fel uppstod vid initiering av betalningen. Försök igen senare.",

  "page.webPayment.stepFinish.info.success": "Betalning gjord, tack!",
  "page.webPayment.stepFinish.info.failure": "Betalningen misslyckades.",
  "page.webPayment.stepFinish.failureInfo": "Betalningen kan ha misslyckats av olika anledningar.",
  "page.webPayment.stepFinish.failureInfoList.heading": "Möjliga orsaker inkluderar",
  "page.webPayment.stepFinish.failureInfoList.item1": "Du avbröt betalningen",
  "page.webPayment.stepFinish.failureInfoList.item2": "Otillräckligt saldo på bankkontot",
  "page.webPayment.stepFinish.failureInfoList.item3": "Kreditkortets kreditgräns",
  "page.webPayment.stepFinish.failureInfoList.item4": "Anslutningsproblem mellan banken och betaltjänsten",
  "page.webPayment.stepFinish.failureInfoList.item5": "Begränsningar för onlinebetalning på betalkortet",
  "page.webPayment.stepFinish.failureInfoList.footer": "Kontakta din bank vid behov.",
  "page.webPayment.stepFinish.info.receipt": "Ditt kvitto kommer att skickas till {email}.",
  "page.webPayment.stepFinish.button.newPayment": "Betala för ett annat besök",
  "page.webPayment.stepFinish.button.tryAgain": "Försök igen",
  "page.webPayment.stepFinish.backToFacilitySiteButtonText": "Finavia.fi/sv",

  "page.webPayment.paymentRedirectReceiver.heading": "Bearbetar betalning...",

  "page.webPayment.label.customerService.part1": "Vid eventuella problem kontakta",
  "page.webPayment.label.customerService.part2": "Finavias kundtjänst",
  "page.webPayment.label.customerService.urlTitle": "Finavias kundtjänst",

  "common.units.hours.short": "h",
  "common.units.minutes.short": "min",
  "common.units.seconds.short": "s",
  "common.button.back": "Tillbaka",
  "language": "Språk",
  "language.fi": "Suomeksi",
  "language.en": "In English",
  "language.sv": "På svenska"
}
